import { CONFLICT_TYPE_LABEL } from '../clientPeriodCard.definitions';
import { CALENDAR_BAR_CLASSES, barToneStyle } from '../../../vacationClientPanel.definitions';
import type { ConflictPersonItem } from '../clientPeriodCard.types';
import type { ConflictCalendarModel } from '../../../vacationClientPanel.calendar';

interface ToneLegendProps {
    people?: ConflictPersonItem[];
    model?: ConflictCalendarModel | null;
}

export function ToneLegend({ people = [], model }: ToneLegendProps) {
    const peopleTones = Array.from(new Set(people.map(p => p.type)));
    const modelTones = model ? Array.from(new Set(model.rows.filter(r => r.tone !== 'self').map(r => r.tone))) : [];
    const allTones = Array.from(new Set([...peopleTones, ...modelTones])).sort();

    if (allTones.length === 0) return null;

    return (
        <div className="flex items-center gap-4">
            {allTones.map((type) => (
                <div key={type} className="flex items-center gap-1.5">
                    <div
                        className={CALENDAR_BAR_CLASSES[type as keyof typeof CALENDAR_BAR_CLASSES]}
                        style={{ ...barToneStyle(type), width: '16px', height: '8px', borderRadius: '4px' }}
                    />
                    <span className="text-[11px] text-raro-gray-600">{CONFLICT_TYPE_LABEL[type]}</span>
                </div>
            ))}
        </div>
    );
}
